module.exports = __webpack_public_path__ + "static/Pump-Station-pg2-e9e854368bde75e4a4f657fc06eb2bcc.jpg";